const baseFieldStyle = { field: { borderRadius: "15px" } }

export const Select = {
  parts: ["field", "addon"],
  baseStyle: {
    field: {
      // A bug in FF prevents externally hosted fonts to be applied to select options.
      // Fallback to sans-serif.
      // @see https://stackoverflow.com/a/67825789/2270233
      fontFamily: "'Manrope Variable', sans-serif",
    },
  },
  sizes: {
    lg: baseFieldStyle,
    md: baseFieldStyle,
    sm: baseFieldStyle,
    xs: baseFieldStyle,
  },
  defaultProps: {
    variant: "filled",
    focusBorderColor: "main.700",
  },
}
